// extracted by mini-css-extract-plugin
export default {"filter":"PriceFilter_filter__VDILz"};